import React from 'react';

const Spinner = ({ loading }: Props) => {
  if(loading) {
    return (
      <div className="spinner">
        <div className="sk-wave sk-primary">
          <div className="sk-wave-rect"></div>
          <div className="sk-wave-rect"></div>
          <div className="sk-wave-rect"></div>
          <div className="sk-wave-rect"></div>
          <div className="sk-wave-rect"></div>
        </div>
      </div>
    );
  }
  return null;
}

interface Props {
  loading: boolean
}

export { Spinner };